<template>
    <section v-if="hasPermissions(['QC-Inspection-Items Read','QC-Inspection-Items Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is where you can create tasks or items to add them to an inspection. Here, you can create and customize your inspection items to match the requirements of your inspections.
            </p>
        </div>
        <div class="bar-container mb-0">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="master_step_codes.length && hasPermissions(['QC-Inspection-Items Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'inspection_items_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['QC-Inspection-Items Write'])"
                />
                <button v-if="hasPermissions(['QC-Inspection-Items Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="modal_deletion()"/>
            </div>
            <div v-if="hasPermissions(['QC-Inspection-Items Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <div class="formdynamic__item col-md-2 py-0 mb-4 mt-2">
            <div class="formdynamic__item__field">
                <label class="modal-label input-date-template">View inspection items:</label>
                <select class="input-field custom-select" v-model="status">
                    <option :value="item.id" v-for="(item, index) in status_options" :key="index" v-html="item.name" />
                </select>
            </div>
        </div>
        <div class="tab-content" v-show="master_step_codes_list.length && hasPermissions(['QC-Inspection-Items Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :selectable_columns="false"
                                :headers="table_headers"
                                :items="master_step_codes_list"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                @emitToParent="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New QC Inspection Item'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
            ref="form_modal"
        />

        <UpdateModal 
            :title="'QC Inspection Item Code Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
            ref="update_modal"
        />
        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        />

        <DeletionValidationModal 
            :validation_table_headers="deletion_validation_table_headers"
            :validate_data="validate_data"
            :breadcrumb="breadcrumb"
            message="The following inspection items were not deleted because there are inspections rooms are linked to them. Please note that these inspection rooms may also be linked to items in the recycle bin."
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import UploadSummary        from    '@/components/UploadSummary'
import UploadOptions        from    '@/components/UploadOptions'
import HelperModal          from    '@/components/HelperModal'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormResources        from    './form_resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import DeletionValidationModal          from    '@/components/DeletionValidationModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'MasterStepmaster_step_codes',

    components: {
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UnauthorizedComponent,
        UploadSummary,
        UploadOptions,
        DeletionValidationModal,
        HelperModal
    },
    data() {
        return {
            notyf,
            axios,
            title_page:         'QC Inspection Items',
            content_header:     this.$store.state.headers,
            rest_api:           `master_step_codes`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            empty_format_data:  Resources.empty_format_data,
            excel_file_headers: Resources.excel_file_headers,
            status_options:     FormResources.status_options,
            excel_data:         [],
            add_btn:            'Add QC Inspection Item',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            master_step_codes:  [],
            array_options:      {
                room_type_id: []
            },
            select_ids:         [],
            name_file_summary: '',
            deletion_validation_table_headers: Resources.deletion_validation_table_headers,
            validate_data: [],
            summary: [],
            status: 1,
            helps: Resources.helps
        }
    },
    methods: {

        unshift_object(new_object) 
        {
            this.master_step_codes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            let found_index = this.master_step_codes.findIndex(item => item.decrypted_id === splicing_object.single_object.decrypted_id)
            if(found_index > -1)
            {
                this.master_step_codes.splice(found_index, 1, splicing_object.single_object)
            }
        },

        form_modal()
        {
            this.array_options.room_type_id.forEach(item => item.checked = false)
            window.$('#static').modal('show')
        },

        modal_deletion()
        {
            this.select_ids = this.master_step_codes_list.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.master_step_codes_list[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.master_step_codes = data.master_step_codes
            this.array_options = {
                room_type_id: data.room_types
            }
        },

        trashing(index)
        {
            this.master_step_codes_list.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.master_step_codes_list.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
            ids: this.select_ids,
            }

            this.loader(true)

            let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

            this.loader()

            if(response.status)
            {
                const validation_data = response.data.deletion_validations

                if(validation_data.length)
                {
                    window.$('#deletion-validations').modal('show')
                    this.validate_data = validation_data
                }

                window.$('#static-deletion-massive').modal('hide')

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.master_step_codes_list.findIndex(value => value.decrypted_id == item)
                    if(index > -1)
                    {
                        this.master_step_codes_list.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            this.name_file_summary = 'inspection_items_failed_template_file'

            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                await this.api_request()
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection-Items Read','QC-Inspection-Items Write']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.master_step_codes_list.filter(item => item.checked)
            return Boolean(bool.length)
        },

        master_step_codes_list()
        {
            if(this.status !== 3)
            {
                const master_step_codes = this.master_step_codes.filter(item => item.status == this.status)
                return master_step_codes
            }

            return this.master_step_codes
        }
    },
}
</script>